import { useState } from 'react';

const faqItems = [
  {
    id: 1,
    q: '被窝网电影的电视剧真的完全免费吗？需要注册会员吗？',
    a: '是的，被窝网电影所有电视剧资源完全免费在线观看，无需注册会员，也不需要充值。打开网站即可直接观看高清全集，没有任何隐藏收费。',
  },
  {
    id: 2,
    q: '观看电视剧需要下载播放器或安装插件吗？',
    a: '不需要。被窝网电影采用网页端直接播放技术，使用浏览器即可观看，无需下载任何播放器或安装插件。支持 Chrome、Safari、Edge 等主流浏览器。',
  },
  {
    id: 3,
    q: '为什么叫"被窝网"？手机上看剧体验怎么样？',
    a: '被窝网电影的名字寓意"在被窝里舒舒服服追剧"。我们的移动端体验经过专门优化，躺在床上用手机就能流畅观看高清电视剧，支持画质调节和倍速播放，追剧体验一流。',
  },
  {
    id: 4,
    q: '电视剧更新速度快吗？热播剧什么时候能看上？',
    a: '被窝网电影每日更新最新剧集，热播电视剧通常当天同步上线。全集资源也会在剧集完结后第一时间收录整理，确保追剧不断更。',
  },
  {
    id: 5,
    q: '播放会卡顿或缓冲吗？对网速要求高吗？',
    a: '我们采用先进的视频传输和编码技术，在保证高清画质的同时大幅降低带宽需求。普通家庭宽带即可流畅观看，弱网环境下也会自动适配清晰度，减少缓冲等待时间。',
  },
  {
    id: 6,
    q: '想看的电视剧找不到怎么办？可以推荐片源吗？',
    a: '如果没找到你想看的电视剧，欢迎通过"联系我们"板块提交剧集推荐。我们的内容团队会定期评估用户需求并扩充片源库，尽全力满足剧迷的追剧需求。',
  },
];

export default function SectionFaq() {
  const [openId, setOpenId] = useState<number | null>(1);

  const toggle = (id: number) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-100" style={{ scrollMarginTop: '64px' }}>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            常见问题
          </span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">常见问题 · 追剧疑问解答</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">关于被窝网电影电视剧观看的常见疑问，这里都有答案</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((item) => (
            <div
              key={item.id}
              className="rounded-xl bg-background-50 border border-background-200/70 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
                onClick={() => toggle(item.id)}
              >
                <h3 className="text-sm md:text-base font-medium text-foreground-900 pr-4">{item.q}</h3>
                <span className={`flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center transition-transform duration-300 ${openId === item.id ? 'bg-primary-500 text-background-50 rotate-45' : 'bg-background-200 text-foreground-500'}`}>
                  <i className="ri-add-line text-sm"></i>
                </span>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openId === item.id ? 'max-h-96 pb-5 px-5' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}